<a [routerLink]="routerLink">{{ data.name }}</a>
@if (data.description) {
  <div class="text-sm">
    {{ data.description }}
  </div>
}
